import { PagePlatformInfo } from './Info';

export const INFO = {
  PlatformInfo: PagePlatformInfo,
} as const;
